import { render } from "./joystick.vue?vue&type=template&id=7cf904ee&scoped=true"
import script from "./joystick.vue?vue&type=script&lang=js"
export * from "./joystick.vue?vue&type=script&lang=js"

import "./joystick.vue?vue&type=style&index=0&id=7cf904ee&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7cf904ee"]])

export default __exports__